import { useEffect } from "react";

const SITE_NAME = "AMADI Legal Consultancy";
const DEFAULT_TITLE =
  "AMADI Legal Consultancy — Middle East & Africa Legal Advisory";
const DEFAULT_DESCRIPTION =
  "AMADI Legal Consultancy advises founders, boards, and investors on corporate structuring, compliance, and cross-border matters across the UAE and Africa.";

const upsertMeta = (attr, key, content) => {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
};

const upsertCanonical = (href) => {
  let el = document.head.querySelector('link[rel="canonical"]');
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", "canonical");
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
};

// Sets per-page <title>, meta description, canonical URL and Open Graph tags.
export const useDocumentMeta = ({ title, description, path, image, type, rawTitle } = {}) => {
  useEffect(() => {
    const fullTitle = title ? (rawTitle ? title : `${title} — ${SITE_NAME}`) : DEFAULT_TITLE;
    const desc = description || DEFAULT_DESCRIPTION;
    const canonical = `${window.location.origin}${path ?? window.location.pathname}`;

    document.title = fullTitle;
    upsertMeta("name", "description", desc);
    upsertMeta("property", "og:title", fullTitle);
    upsertMeta("property", "og:description", desc);
    upsertMeta("property", "og:type", type || "website");
    upsertMeta("property", "og:url", canonical);
    upsertMeta("property", "og:site_name", SITE_NAME);
    upsertMeta("name", "twitter:title", fullTitle);
    upsertMeta("name", "twitter:description", desc);
    if (image) {
      upsertMeta("property", "og:image", image);
      upsertMeta("name", "twitter:image", image);
      upsertMeta("name", "twitter:card", "summary_large_image");
    } else {
      upsertMeta("name", "twitter:card", "summary");
    }
    upsertCanonical(canonical);
  }, [title, description, path, image, type, rawTitle]);
};
